<svg>
  <use [attr.xlink:href]="'/assets/stusan/icons/sprite.svg#' + icon"></use>
</svg>
